import React from 'react';

import { IonItem, IonList } from '@ionic/react';

import Typography from 'components/Typography';
import { useDownloadAttachment } from 'scenes/FinancePage/IO/data/mutations/useDownloadAttachment';

interface IAttachments {
  data: any[];
}

const Attachments = ({ data = [] }: IAttachments) => {
  const [download] = useDownloadAttachment();
  return (
    <>
      <IonList>
        {data.map((row: any) => (
          <IonItem
            key={row.id}
            button={true}
            detail={false}
            lines={'full'}
            className={'padding-top padding-bottom'}
            onClick={() =>
              download({ id: row.id, url: row.uri, fileName: row.name })
            }
          >
            <div>
              {row.type.name && row.id ? (
                <Typography variant={'overline'} color={'medium-shade'}>
                  {`${row.type.name} / #${row.id}`}
                </Typography>
              ) : null}
              <Typography variant={'subtitle1'} color={'primary'}>
                {row.name || row.uri}
              </Typography>
              <Typography>{row.description}</Typography>
            </div>
          </IonItem>
        ))}
      </IonList>
    </>
  );
};
export default Attachments;
